/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainEntitiesDocumentsGeoTarget, FxIdDomainEntitiesDocumentsGeoTargetFromJSONTyped, FxIdDomainEntitiesDocumentsGeoTargetToJSON, } from './FxIdDomainEntitiesDocumentsGeoTarget';
export function FxIdDomainEntitiesDocumentsDocumentGeoFromJSON(json) {
    return FxIdDomainEntitiesDocumentsDocumentGeoFromJSONTyped(json, false);
}
export function FxIdDomainEntitiesDocumentsDocumentGeoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainEntitiesDocumentsGeoTarget(json)) {
        return FxIdDomainEntitiesDocumentsGeoTargetFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainEntitiesDocumentsDocumentGeoToJSON(json) {
    return FxIdDomainEntitiesDocumentsDocumentGeoToJSONTyped(json, false);
}
export function FxIdDomainEntitiesDocumentsDocumentGeoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainEntitiesDocumentsGeoTarget(value)) {
        return FxIdDomainEntitiesDocumentsGeoTargetToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainEntitiesDocumentsDocumentGeo.js.map